import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Cursor from "@/components/Cursor";
import ScrollProgress from "@/components/ScrollProgress";
import Loader from "@/components/Loader";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Concierge from "@/components/Concierge";
import Home from "@/pages/Home";
import Prive from "@/pages/Prive";
import Collective from "@/pages/Collective";
import DestinationsHub from "@/pages/DestinationsHub";
import CountryDetail from "@/pages/CountryDetail";
import DestinationDetail from "@/pages/DestinationDetail";
import Legal from "@/pages/Legal";
import Enquiry from "@/pages/Enquiry";
import About from "@/pages/About";
import AdminLogin from "@/pages/AdminLogin";
import AdminInbox from "@/pages/AdminInbox";

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  return (
    <SmoothScroll>
      {!isAdmin && <Loader onDone={() => {}} />}
      {!isAdmin && <Cursor />}
      {!isAdmin && <ScrollProgress />}
      {!isAdmin && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/prive" element={<Prive />} />
        <Route path="/collective" element={<Collective />} />
        <Route path="/destinations" element={<DestinationsHub />} />
        <Route path="/destinations/country/:slug" element={<CountryDetail />} />
        <Route path="/destinations/:slug" element={<DestinationDetail />} />
        <Route path="/legal/:type" element={<Legal />} />
        <Route path="/enquire" element={<Enquiry />} />
        <Route path="/about" element={<About />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminInbox />} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && <Concierge />}
      <Toaster position="bottom-center" theme="dark" toastOptions={{ style: { background: "#0D1038", color: "#F8F7F3", border: "1px solid rgba(212,175,55,0.4)" } }} />
    </SmoothScroll>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </div>
  );
}

export default App;
